import { useQuery } from '@tanstack/react-query'

import type {
  ApiError,
  NumberComparisonRequest,
  NumberComparisonResponse,
} from '@mangovoice/types'

import { useReportingApi } from '../api/context'
import { REPORTING_QUERY_KEYS } from '../api/endpoints'

interface UseGetNumberComparisonParams {
  request?: NumberComparisonRequest
  enabled?: boolean
}

export const useGetNumberComparison = ({
  request,
  enabled = true,
}: UseGetNumberComparisonParams) => {
  const api = useReportingApi()

  return useQuery<NumberComparisonResponse, ApiError>({
    queryKey: [REPORTING_QUERY_KEYS.numberComparison, request],
    queryFn: async () => {
      if (!request) throw new Error('Request is required')

      const { ok, data } = await api.getNumberComparison(request)

      if (!ok) {
        return Promise.reject(data as ApiError)
      }

      if (!data) {
        return Promise.reject(
          new Error('No data returned from number comparison API'),
        )
      }

      return data
    },
    enabled: enabled && !!request,
    retry: false,
  })
}
